var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('video',{ref:"videoPlayer",staticStyle:{"width":"95%","min-width":"450px"},attrs:{"controls":"","autoplay":"off","id":"videoPlaceholder","controlsList":"nodownload","allowFullScreen":"","frameborder":"0","height":"376"}},[_c('source',{attrs:{"src":this.current.video_url,"type":"video/mp4"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }